import { Component, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [SharedModule],
  template: `<section class="container">
    <h1>Page not found</h1>
    <p>The page you are looking for doesn’t exist.</p>
  </section>`,
})
export class NotFoundComponent {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  constructor() {
    this.title.setTitle('404 Not Found | Qautos');
    this.meta.updateTag({ name: 'robots', content: 'noindex, follow' });
  }
}
